<adaa-item-slider class="my-3" [showPerformance]="showOverall()" [scrollInput]="232" [arrowsInHeader]="true">
    <h5 title class="py-2 enabler-perf__title">
        {{ "landingPage.entity_page.government_enabler_performance" | translate }}
        <b>{{ periodLabel() }}</b>
    </h5>

    <!-- The [performance] host stays a static child: Angular resolves projection
         slots at compile time, so a node behind @if or a structural directive
         falls into the default slot and lands inside the scrolling rail. -->
    <div performance class="enabler-perf__overall d-flex flex-column align-items-center justify-content-center" [class.d-none]="!showOverall()">
        @if (overallPillar(); as overall) {
            <adaa-doughnut
                [size]="'md'"
                [amount]="overall.govEnablerPerformance!"
                [colorId]="overallColorId()"
                [colorizeValue]="true"
                [label]="'landingPage.entity_page.enabler_performance' | translate"
            />

            <button class="btn-primary-faded" (click)="selectedGovEnablerPerf.set(undefined); openPerformanceGraph(performanceGraphModal)">
                <fa-icon [icon]="graphIcon" />
                {{ "common.form.label.performance_comparison" | translate }}
            </button>
        }
    </div>

    @for (pillar of pillars(); track pillar.id) {
        <adaa-gov-enabler-perf-card
            *adaaHasPermission="pillarPermission"
            [data]="pillar"
            (graphClicked)="selectedGovEnablerPerf.set($event); openPerformanceGraph(performanceGraphModal)"
        />
    }
</adaa-item-slider>

<ng-template #performanceGraphModal let-modal>
    <adaa-entity-comparison-modal
        elementId="performanceChart"
        [title]="chartTitle"
        [entities]="entitiesPerformance()"
        [average]="averagePerformance()"
        [selectedPeriod]="selectedPeriod()"
        [showEntityTypeAndSize]="showEntityTypeAndSize()"
        [enableDownloadCSV]="true"
        [csvRows]="performanceCsvRows()"
        [csvRowHeaders]="['common.form.label.entity', 'data_entry.performance', 'common.form.label.average']"
        (filterChanged)="onFilterChange($event)"
        (closed)="selectedGovEnablerPerf.set(undefined); modal.dismiss()"
    />
</ng-template>
